import { render, staticRenderFns } from "./PasswordVault.vue?vue&type=template&id=3b522283"
import script from "./PasswordVault.vue?vue&type=script&lang=js"
export * from "./PasswordVault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports